interface ConfidenceIndicatorProps {
  confidence: number;
  size?: 'sm' | 'md';
}

function getBarColor(confidence: number): string {
  if (confidence < 0.4) return 'bg-red-500';
  if (confidence < 0.7) return 'bg-yellow-500';
  return 'bg-green-500';
}

export default function ConfidenceIndicator({
  confidence,
  size = 'sm',
}: ConfidenceIndicatorProps) {
  const pct = Math.round(confidence * 100);
  const barHeight = size === 'sm' ? 'h-1.5' : 'h-2.5';
  const textSize = size === 'sm' ? 'text-[10px]' : 'text-xs';

  return (
    <div className="flex items-center gap-1.5 min-w-[60px]">
      <div className={`flex-1 rounded-full bg-gray-200 ${barHeight}`}>
        <div
          className={`${barHeight} rounded-full transition-all ${getBarColor(confidence)}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className={`${textSize} font-medium text-gray-500 tabular-nums`}>
        {pct}%
      </span>
    </div>
  );
}
